<template>
  <div>
    <!-- Componente para gerar QR Code -->
    <canvas ref="qrcodeCanvas"></canvas>
    <!-- <p>Link: <a :href="dynamicLink" target="_blank">{{ dynamicLink }}</a></p> -->
    <p>Escaneie o QrCode ou <a :href="dynamicLink" target="_blank">Clique aqui! </a></p>

    <canvas ref="qrcodeCanvas"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'; // Importando a biblioteca qrcode

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    logo: {
      type: String, // URL da imagem
      default: ""   // Pode ser uma URL ou caminho local
    }
  },
  data() {
    return {
      dynamicLink: this.value, // Link que será passado ao componente
    };
  },
  mounted() {
    // Gerando o QR Code após o componente ser montado
    this.generateQRCode(this.dynamicLink);
  },
  methods: {
    async generateQRCode() {
      try {
        const canvas = this.$refs.qrcodeCanvas;
        const ctx = canvas.getContext("2d");

        // Gera o QR Code no Canvas
        await QRCode.toCanvas(canvas, this.value, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        });

        // Adiciona a imagem no centro do QR Code, com fundo branco para a área do logo
        if (this.logo) {
          const image = new Image();
          image.src = this.logo;
          image.onload = () => {
            const canvasSize = canvas.width;
            const imageSize = canvasSize * 0.25; // 25% do tamanho do QR Code
            const x = (canvasSize - imageSize) / 2;
            const y = (canvasSize - imageSize) / 2;

            // Preenche a área com fundo branco
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(x, y, imageSize, imageSize);

            // Desenha o logo
            ctx.drawImage(image, x, y, imageSize, imageSize);
          };
        }
      } catch (error) {
        console.error("Erro ao gerar o QR Code:", error);
      }
    }
  }
};
</script>

<style scoped>
/* Adiciona estilos para o canvas se necessário */
canvas {
  margin-top: 20px;
  max-width: 100%;
}
</style>
